import type { ReactNode } from 'react';
import { initials, identityColor, personName } from './identity';

export interface Person {
  name?: string;
  /** Organisation for a requester; team or tier for an assignee. */
  detail?: string;
}

/**
 * The 24px square avatar + name + sub-line used by the header band's REQUESTER
 * and ASSIGNED cells.
 *
 * Extracted per phase 9's audit: this shape had started to be re-implemented in
 * more than one place, and the whole point of the record-column pass is one
 * renderer per fact. Anything showing a person in the ticket header uses this.
 */
export function PersonCell({
  person,
  trailing,
  nameClassName,
}: {
  person: Person;
  /** Overrides the name colour (e.g. accent when the cell is a link). */
  nameClassName?: string;
  /** Optional affordance (a chevron when the cell is a control). */
  trailing?: ReactNode;
}) {
  return (
    <div className="flex min-w-0 items-center gap-[8px]">
      <span
        className="flex h-[24px] w-[24px] flex-none items-center justify-center text-[9.5px] font-semibold text-[var(--co-ink-invert)]"
        style={{ background: identityColor(person.name) }}
      >
        {initials(person.name)}
      </span>
      <span className="min-w-0">
        <span className={`block truncate text-[13px] font-semibold leading-none ${nameClassName ?? 'text-[var(--co-ink)]'}`}>
          {personName(person.name) || 'Unknown'}
        </span>
        {person.detail && (
          <span className="mt-[4px] block truncate text-[11.5px] leading-none text-[var(--co-ink-3)]">
            {person.detail}
          </span>
        )}
      </span>
      {trailing}
    </div>
  );
}

export default PersonCell;
